<template>
  <main class="flex flex-wrap p-3 md:p-7 lg:p-20 min-h-full">
    <div class="w-full">
      <div
        class="flex flex-col text-left md:flex-row md:items-center justify-between"
      >
        <h4 class="app-heading font-medium">Employees</h4>
        <button
          @click="addEmployee()"
          class="btn bg-primary mt-3 md:mt-0"
          :disabled="loading"
        >
          Add New
        </button>
      </div>
    </div>

    <div class="w-full">
      <Card
        class="w-full text-left flex mt-4 md:mt-6 flex-col md:flex-row md:items-center justify-between mb-6 p-4 md:p-7 lg:p-10"
      >
        <h4
          class="app-heading font-medium text-sm md:text-2xl lg:text-3xl text-left"
        >
          Josh Bakery Ventures
        </h4>
        <p class="text-xs sm:text-sm">62, Bode Thomas, Surulere, Lagos</p>
      </Card>
    </div>

    <div class="w-full py-8">
      <employee-filter />

      <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
        <div class="block relative min-w-full overflow-x-hiddens">
          <div
            v-if="loading"
            class="loading absolute h-full w-full flex justify-center items-center bg-gray-100"
          >
            <svg
              version="1.1"
              id="loader-1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="40px"
              height="40px"
              viewBox="0 0 50 50"
              style="enable-background:new 0 0 50 50;"
              xml:space="preserve"
            >
              <path
                fill="#000"
                d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
              >
                <animateTransform
                  attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="0.6s"
                  repeatCount="indefinite"
                ></animateTransform>
              </path></svg
            ><br />
            <button
              @click="fetchEmployees()"
              class="btn bg-primary mt-3 md:mt-0"
              v-if="error && !loading"
            >
              Reload
            </button>
          </div>
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th class="">
                  <label class="flex justify-center items-center">
                    <div class="checkbox ml-3">
                      <input type="checkbox" class="opacity-0 absolute" />
                      <svg
                        class="fill-current hidden w-4 h-4 text-green-500 pointer-events-none"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20,3H4C3.447,3,3,3.447,3,4v16c0,0.553,0.447,1,1,1h16c0.553,0,1-0.447,1-1V4C21,3.447,20.553,3,20,3z"
                        />
                      </svg>
                    </div>
                    <!-- <div class="select-none">Label Text</div> -->
                  </label>
                </th>
                <th class="">First Name</th>
                <th class="">Last Name</th>
                <th class="">Email</th>
                <th class="">Phone</th>
                <th class="">Role</th>
                <th class=""></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="employees.length == 0 && !loading">
                <td class="" colspan="7">
                  <div
                    class="w-full flex justify-center ml-3 whitespace-no-wrap"
                  >
                    <p class="text-gray-900 text-center">
                      <svg
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        class="mx-auto emoji-sad w-6 h-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                      </svg>
                      No data to show
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-for="employee in employees" :key="employee._id">
                <td class="">
                  <div class="flex items-center ml-3 whitespace-no-wrap">
                    <label class="flex justify-center items-center">
                      <div class="checkbox">
                        <input type="checkbox" class="opacity-0 absolute" />
                        <svg
                          class="fill-current hidden w-4 h-4 text-green-500 pointer-events-none"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M20,3H4C3.447,3,3,3.447,3,4v16c0,0.553,0.447,1,1,1h16c0.553,0,1-0.447,1-1V4C21,3.447,20.553,3,20,3z"
                          />
                        </svg>
                      </div>
                      <!-- <div class="select-none">Label Text</div> -->
                    </label>
                  </div>
                </td>
                <td class="">
                  <div class="flex items-center ml-3 whitespace-no-wrap">
                    <p class="text-gray-900">
                      {{ employee.firstname }}
                    </p>
                  </div>
                </td>
                <td class="">
                  <div class="flex items-center ml-3 whitespace-no-wrap">
                    <p class="text-gray-900">
                      {{ employee.lastname }}
                    </p>
                  </div>
                </td>
                <td class="">
                  <div class="flex items-center ml-3 whitespace-no-wrap">
                    <p class="text-gray-900">
                      {{ employee.email }}
                    </p>
                  </div>
                </td>
                <td class="">
                  <div class="flex items-center ml-3 whitespace-no-wrap">
                    <p class="text-gray-900">
                      {{ employee.phone }}
                    </p>
                  </div>
                </td>
                <td class="px-5 py-4 border-b border-gray-200 bg-white text-sm">
                  <div class="flex items-center">
                    <div class="ml-3">
                      <p class="text-gray-900 whitespace-no-wrap">
                        {{ employee.role }}
                      </p>
                    </div>
                  </div>
                </td>
                <td class="px-5 py-4 border-b border-gray-200 bg-white text-sm">
                  <a
                    class="cursor-pointer"
                    :disabled="loading"
                    @click="deleteEmployee(employee._id)"
                  >
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="trash w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Card from "../../components/Card";
import EmployeeFilter from "../../components/EmployeeFilter";

var roles = ["admin", "staff"],
  API_URL = `https://crudcrud.com/api/4bef012dcdd44c758de73fd714de0953`;

export default {
  name: "home",
  components: {
    Card,
    EmployeeFilter
  },
  data() {
    return {
      loading: false,
      employees: [],
      error: false,
      employee: {
        firstname: "Joshua",
        lastname: "Bakare",
        email: "josh.bakery@gmail.com",
        phone: "+2348012345678",
        role: roles[Math.floor(Math.random() * roles.length)]
      }
    };
  },
  mounted() {
    this.fetchEmployees();
  },
  methods: {
    async addEmployee() {
      this.loading = true;
      try {
        let response = await fetch(`${API_URL}/employees`, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.employee)
        });
        let data = await response.json();
        this.employees.push(data);
      } catch (err) {
        alert(err);
        this.error = false;
      }
      this.loading = false;
    },

    async fetchEmployees() {
      this.loading = true;
      try {
        let response = await fetch(`${API_URL}/employees`);
        let data = await response.json();
        this.employees = data;
      } catch (err) {
        alert(err);
        this.error = true;
      }
      this.loading = false;
    },

    async deleteEmployee(employee_id) {
      this.loading = true;
      try {
        let response = await fetch(`${API_URL}/employees/${employee_id}`, {
          method: "DELETE",
          headers: {
            Accept: "application/json"
          }
        });
        this.loading = false;
        let data = await response.text();

        return this.fetchEmployees();
      } catch (err) {
        alert(err);
        this.error = true;
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
th {
  @apply px-5 py-3 text-left text-xs font-medium uppercase tracking-wider;
  color: #013c61;
}

td {
  @apply px-5 py-4 border-b border-gray-200 text-sm;
}
tbody tr {
  @apply bg-white;
}

tbody tr td:first-child {
  @apply rounded-l-md;
}

tbody tr td:last-child {
  @apply rounded-r-md;
}

.checkbox {
  @apply bg-white border-2 rounded border-gray-400 w-4 h-4 flex flex-shrink-0 justify-center items-center mr-2;
}
input:checked + svg {
  display: block;
}

.loading svg path,
.loading svg rect {
  fill: #2bda53;
}
</style>
